import { axiosInstance as request } from '@api/rest.service'

const api = '/subscription-periods/task-applicability'

/**
 * @description GET /subscription-periods/task-applicability/general
 * @returns {AxiosPromise<any>}
 */
export const GET_GENERAL_TASK_APPLICABILITY = () => request.get(`${api}/general`)

/**
 * @description PUT /subscription-periods/task-applicability/general
 * @returns {AxiosPromise<any>}
 */
export const UPDATE_GENERAL_TASK_APPLICABILITY = payload => request.put(`${api}/general`, payload)

/**
 * @description /subscription-periods/task-applicability?filter[${filter}]=true
 * @returns {AxiosPromise<any>}
 */
export const GET_FILTERED_TASK_APPLICABILITY = filter => request.get(`${api}?filter[${filter}]=true`)

/**
 * @description PATCH /subscription-periods/task-applicability
 * @returns {AxiosPromise<any>}
 */
export const MODIFY_TASK_APPLICABILITY = payload => request.patch(api, payload)
